export default "__VITE_ASSET__DcLRvp3W__"